import {Unlink} from 'lucide-react';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'src/Button';
import {useModals} from 'src/Modals';
import type {FullRawTransactionFragment} from '@transactions/graphql';

type Props = {
  rawTransaction: FullRawTransactionFragment;
};

/**
 * Benefit link on the raw transaction detail page. The benefit is not part
 * of the UpdateRawTransaction payload — link/unlink are their own mutations
 * and apply immediately — so this field keeps its own affordances (modals)
 * rather than living in the edit form.
 */
export const BenefitField = ({rawTransaction}: Props) => {
  const {linkBenefitModal, unlinkBenefitTransactionModal} = useModals();

  const {benefit} = rawTransaction;

  const handleLink = () => {
    linkBenefitModal.openModal({
      rawTransaction,
      currentBenefitName: benefit?.name,
    });
  };

  const handleUnlink = () => {
    unlinkBenefitTransactionModal.openModal({
      rawTransaction,
      benefitName: benefit?.name,
    });
  };

  return (
    <div className="flex min-h-9 flex-wrap items-center gap-2">
      {benefit ? (
        <Link
          to={`/accounts/${benefit.accountId}/benefits`}
          className="underline"
        >
          {benefit.name}
        </Link>
      ) : (
        <span className="text-muted-foreground italic">(none)</span>
      )}
      <Button
        variant="outline"
        className="h-7 px-2.5 text-xs"
        onClick={handleLink}
      >
        {benefit ? 'Change' : 'Link benefit'}
      </Button>
      {benefit && (
        <Button
          variant="outline"
          className="h-7 gap-1.5 px-2.5 text-xs"
          onClick={handleUnlink}
        >
          <Unlink className="size-3.5" />
          Unlink
        </Button>
      )}
    </div>
  );
};
